import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/error-rounded.svg'


const _withScopeId = n => (_pushScopeId("data-v-5a7ed894"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "div-page-content-desc" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "div-page-content-area" }
const _hoisted_5 = { class: "div-registering-label-row" }
const _hoisted_6 = { class: "full-row-label" }
const _hoisted_7 = { class: "div-registering-input-row" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "div-registering-input-row"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "filterRed",
  src: _imports_0
}, null, -1))
const _hoisted_11 = { class: "validationErrorSmall" }
const _hoisted_12 = { class: "two-button-container" }
const _hoisted_13 = ["disabled"]

import { ref, computed, onMounted } from "vue";
import { Store } from "vuex";
import { index } from "@/store/index";
import { requiredInject } from "@/util/vue";
import { BackendKey } from "@/backend";
import {
  checkAndMarkStringLength,
  isZeroPrefixedInteger
} from "@/util/commonUtils";
import { ErrorField } from "@/util/commonTypes";
import {
  VerifyClientIdRequest,
  VerifyClientIdResponse
} from "@/backend/types/client-existence";
import CustomInfoNoteConfirmation from "@/components/CustomInfoNoteConfirmation.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisteringI18nCheckPatientId',
  emits: ["patientIdInserted", "cancelRegisteringProcess", "showSpinner"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store: Store<unknown> = index;

const backend = requiredInject(BackendKey);

const showCancelConfirmation = ref<boolean>(false);
const screenPosition = ref<number>(-1);

const patientId = ref<string>();
const patientIdNotFound = ref<boolean>();

const justClicked = ref<boolean>(true);

const errorFields = ref<ErrorField[]>([]);

const patientIdInputPlaceholder = computed<string>(() => {
  return index.getters.translate("registering-i18n-patient-id-placeholder");
});

onMounted(() => {
  justClicked.value = false;
});

function inputHasError(fieldStr: string): boolean {
  return errorFields.value.find(x => x.item === fieldStr) !== undefined;
}

function dismissCanceling(): void {
  showCancelConfirmation.value = false;
  // hack because note visibility is made by async items
  setTimeout(scrollBack, 50);
}

function scrollBack(): void {
  if (screenPosition.value > -1) {
    window.scrollTo({ top: screenPosition.value, behavior: "smooth" });
    screenPosition.value = -1;
  }
}

function cancelRegisteringProcess(): void {
  emit("cancelRegisteringProcess");
}

function askCancelProcess(): void {
  screenPosition.value = window.pageYOffset;
  showCancelConfirmation.value = true;
}

function resetError(fieldStr: string): void {
  errorFields.value = errorFields.value.filter(x => x.item !== fieldStr);
  patientIdNotFound.value = false;
}

function validatePatientId(): boolean {
  if (
    !checkAndMarkStringLength(
      patientId.value ?? "",
      7,
      7,
      "patientId",
      errorFields.value
    )
  ) {
    return false;
  }
  if (!isZeroPrefixedInteger(patientId.value ?? "")) {
    errorFields.value.push({ item: "patientId" });
    return false;
  }
  return true;
}

function updateClientData(response: VerifyClientIdResponse): void {
  if (response.clientId) {
    store.commit("SET_USER_CLIENT_ID", response.clientId);
  }
  if (response.phoneNumber) {
    store.commit("SET_USER_PHONE_NUMBER", response.phoneNumber);
  }
  if (response.emailAddress) {
    store.commit("SET_USER_EMAIL_ADDRESS", response.emailAddress);
  }
  if (response.streetAddress) {
    store.commit("SET_USER_STREET_ADDRESS", response.streetAddress);
  }
  if (response.postalCode) {
    store.commit("SET_USER_POSTAL_CODE", response.postalCode);
  }
  if (response.city) {
    store.commit("SET_USER_CITY", response.city);
  }
  if (response.countryCode) {
    store.commit("SET_USER_COUNTRY_CODE", response.countryCode);
  }
}

function continueProcess(): void {
  if (validatePatientId()) {
    emit("showSpinner", true);
    justClicked.value = true;
    const checkClientIdRequest: VerifyClientIdRequest = {
      acuteId: patientId.value ?? ""
    };
    backend
      .checkClientId(checkClientIdRequest)
      .then(resp => {
        if (resp.clientExists) {
          console.log("patientId check ok");
          updateClientData(resp);
          emit("patientIdInserted");
        } else {
          patientIdNotFound.value = true;
          console.warn("patientId check not ok");
        }
        justClicked.value = false;
        emit("showSpinner", false);
      })
      .catch(err => {
        console.error("Failed to check patientId!", err);
        justClicked.value = false;
        emit("showSpinner", false);
      });
  }
}

return (_ctx: any,_cache: any) => {
  return (showCancelConfirmation.value)
    ? (_openBlock(), _createBlock(CustomInfoNoteConfirmation, {
        key: 0,
        msg: "COMMON-CONFIRMATION",
        title: _unref(store).getters.translate('abort-registering'),
        header: _unref(store).getters.translate('registering-i18n-abort-confirmation'),
        text1: _unref(store).getters.translate('registering-i18n-abort-description'),
        button1: _unref(store).getters.translate('generic-return-b'),
        button2: _unref(store).getters.translate('abort-registering'),
        onCloseNote: dismissCanceling,
        onCancelOrChange: cancelRegisteringProcess
      }, null, 8, ["title", "header", "text1", "button1", "button2"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-patient-id-give")), 1),
          _hoisted_3,
          _createElementVNode("sub", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-patient-id-sub")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-patient-id-give-b")), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-patient-id-description-1")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(store).getters.translate("registering-i18n-patient-id")), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              id: "registering-i18n-patient-id-input",
              type: "text",
              class: _normalizeClass(["full-row-input", {
            'validation-error': inputHasError('patientId') || patientIdNotFound.value
          }]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((patientId).value = $event)),
              placeholder: patientIdInputPlaceholder.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (resetError('patientId')))
            }, null, 10, _hoisted_8), [
              [_vModelText, patientId.value]
            ])
          ]),
          (inputHasError('patientId') || patientIdNotFound.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(store).getters.translate("registering-i18n-patient-id-not-found")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h3", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-patient-id-unsure")), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-patient-id-description-2")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "buttonReturn",
              onClick: askCancelProcess
            }, _toDisplayString(_unref(store).getters.translate("generic-abort")), 1),
            _createElementVNode("button", {
              class: "buttonContinue",
              onClick: continueProcess,
              disabled: 
            !((patientId.value?.length ?? 0) > 0) ||
              inputHasError('patientId') ||
              patientIdNotFound.value ||
              justClicked.value
          
            }, _toDisplayString(_unref(store).getters.translate("generic-next")), 9, _hoisted_13)
          ])
        ])
      ]))
}
}

})